import type { RouteObject } from 'react-router-dom';
import { paths } from '@/router/paths';
import { BatteryModelListPage } from './BatteryModelListPage';

export const batteryModelRoutes: RouteObject[] = [
  { path: paths.batteryModels, element: <BatteryModelListPage /> }
];
